// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"53af0263","732":"427f735d","977":"3e2259f5"}[chunkId] + ".chunk.js";
};